import { useState } from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Can } from '@/shared/auth/Can'
import { InvoiceFormModal } from './InvoiceFormModal'
import { InvoiceTable } from './InvoiceTable'

export function SubscriberInvoices({ subscriberId }: { subscriberId: string }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [creating, setCreating] = useState(false)

  return (
    <>
      <InvoiceTable
        filter={{ subscriberId }}
        tableId="subscriber-invoices"
        urlPrefix="i"
        showCustomer={false}
        toolbarExtra={
          <Can permission="invoice.create">
            <Button icon={<PlusOutlined />} onClick={() => setCreating(true)}>
              {t('invoices.create')}
            </Button>
          </Can>
        }
      />
      <InvoiceFormModal
        open={creating}
        subscriberId={subscriberId}
        onClose={() => setCreating(false)}
        onSaved={(invoice) => {
          setCreating(false)
          void navigate(`/invoices/${invoice.id}`)
        }}
      />
    </>
  )
}
